import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import type { ExportCollarsResponse } from "./type";

export async function exportCollars(): Promise<ExportCollarsResponse> {
  const response = await apiClient.get<ExportCollarsResponse>(
    apiPaths.devices.collars.export,
  );

  return response.data;
}
